import React, { useMemo, useState } from 'react';

import { BaseReact } from '../../../base.model';
import { ProfileQL } from '../../../models/Profile'
import SectionTitleBar from '../../components/titlebar';
import { useQuery } from '@apollo/react-hooks';
import { graphqlSchema } from '../../../services/graphql.schema';

import SetupMenu from '../Setup.menu';
import AccountAvatarHolder from '../../components/accountAvatarHolder';
import AccountAvatarHolderMobile from '../../components/accountAvatarHolder.mobile';
import { StripePricingPlan } from '../../../models/Stripe';
import SetupPagosHistory from './Setup.Pagos.History';
import AccountInfo from './AccountInfo/AccountInfo';
import AccountPayment from './PaymentDialogs/Account.payment';
import AccountPlans from './AccountPlans/AccountPlans';
import GraphQlClient from '../../../services/graphql';
import './Setup.Pagos.scss';

interface SetupProps extends BaseReact {
    currentUser: ProfileQL;
}

function SetupPagosFiscalPop({ currentUser, history }: SetupProps) {
    // Card States
    const [addPayment, setAddPayment] = useState(false);
    // Prices
    const [pricingPlans, setPricingPlans] = useState<StripePricingPlan[]>([]);

    useQuery(graphqlSchema.STRIPE.PRICES.getPricingPlans, {
        onCompleted: ({ getPricingPlans }: { getPricingPlans: StripePricingPlan[] }) => {
            console.log('Pricing plans gotten: ', getPricingPlans);
            setPricingPlans(getPricingPlans);
        }
    });

    const isClusterAccount = useMemo(() => {
        return !!(currentUser?.billing?.isClusterType && currentUser?.billing?.clusterName);
    }, [currentUser]);

    const closePaymentModal = (paymentResponse: { success: boolean } = null) => {
        setAddPayment(false);
        if (!paymentResponse) {
            return;
        }
        if (paymentResponse.success) {
            setTimeout(() => {
                // Wait for Webhook to process
                GraphQlClient.recallCurrentUser();
            }, 3000);
        }
        console.log('Payment response onClose: ', paymentResponse);
    }

    const openPaymentModal = () => {
        if (isClusterAccount) {
            return;
        }
        setAddPayment(true);
    }

    return (
        <div id="SetupPagosFiscalPop">
            <SectionTitleBar currentUser={currentUser} title="Planes & Pagos" />
            <div className="setupContent">
                <SetupMenu />
                <div className='planSectionSplit'>
                    <div className="plansAndBalance">
                        <div className="card balanceInfo">
                            <AccountAvatarHolder currentUser={currentUser} hideName />
                            <AccountAvatarHolderMobile currentUser={currentUser} />
                            <AccountInfo
                                pricingPlans={pricingPlans}
                                isClusterAccount={isClusterAccount}
                                billingAccount={currentUser.billing}
                                onAddBalanceClick={openPaymentModal}
                            />
                        </div>
                        <AccountPlans
                            pricingPlans={pricingPlans}
                            isClusterAccount={isClusterAccount}
                            billingAccount={currentUser.billing}
                        />
                    </div>
                    <div className="paymentsAndHistory">
                    <SetupPagosHistory
                        currentUser={currentUser}
                        />
                    </div>
                </div>
            </div>
            <AccountPayment isOpen={addPayment} onRequestClose={closePaymentModal} />
        </div >
    )
}

export default SetupPagosFiscalPop;
